
<button 
    mat-raised-button 
    class="button" 
    (click)="search()"
    [disabled]="disableFirstButton"
>{{firstNameButton}}</button>
<button 
    mat-raised-button 
    class="button__white" 
    (click)="resetForm()"
>{{secondNameButton}}</button>
<button 
    mat-raised-button 
    class="button__white" 
    *ngIf="thirdNameButton"
    [disabled]="disableThirdButton"
    (click)="thirdButtonClick()"
><img src="../../../assets/icons/share-icon.svg" style="margin-right: 0.5rem;" alt="svg download">{{thirdNameButton}}</button>

